module.exports = __webpack_public_path__ + "img/gos-bg.364243a.jpg";